/**
 * Frozen copy for the read-and-sign flow.
 *
 * Mirrors `lib/monitoring/acknowledge-copy.ts`. The wording matters more than
 * usual here: signing creates a permanent, uneditable compliance record, so the
 * confirmation has to say so plainly and cannot be softened without product
 * sign-off.
 *
 * "Acknowledgement" already means three other things in this product (closing an
 * incident, signing off failed checks, triaging an alert), so every user-facing
 * string below says "read and sign" instead.
 */
export const ACK_COPY = {
  /** The obligation, as it reads on the staff member's To do list. */
  ROW_ACTION: "Read & sign",
  ROW_NO_DUE_DATE: "No due date",
  ROW_NEEDS_CONNECTION: "Needs connection",

  READER_TITLE: "Read and sign",
  READER_SUPERSEDED:
    "A newer version of this document has been published. You don't need to sign this one.",
  READER_SUPERSEDED_LINK: "Go to the current version",
  READER_ALREADY_SIGNED: "You signed this",

  CONFIRM_TITLE: "Confirm you have read and understood this",
  CONFIRM_WARNING:
    "This is recorded permanently against your name and cannot be undone. Nobody can edit or delete it afterwards.",
  CONFIRM_CANCEL: "Cancel",
  CONFIRM_ACTION: "I confirm I have read and understood",
  CONFIRM_SAVING: "Confirming…",

  TOAST_SIGNED: "Signed — thank you",
  TOAST_SIGN_QUEUED: "Saved — this will sync when you reconnect",
  TOAST_SIGN_ERROR: "Could not record your signature",
  TOAST_REMINDED: "Reminder recorded",
  TOAST_REMIND_ERROR: "Could not send the reminder",
  TOAST_EXPORT_EMPTY: "There is nothing to export yet",

  /**
   * Said out loud because a reminder that delivers nothing is surprising. Under
   * CD-10 acknowledgement reminders are in-platform only — no email, no push —
   * so the manager needs to know what the button actually did.
   */
  REMIND_HELP:
    "Recording a reminder updates the date shown here. It does not send an email or a notification — the request stays on their To do list either way.",
} as const;
